import { useEffect, useRef, useState } from 'react';
import { autocomplete } from '@algolia/autocomplete-js';
import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions';
import '@algolia/autocomplete-theme-classic';
import { useSearchBox } from 'react-instantsearch';

const AutocompleteSearch = ({ searchClient, value = '', onValueChange }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const { refine } = useSearchBox();
  const [inputValue, setInputValue] = useState(value);
  const autocompleteRef = useRef(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    refine(inputValue); // Only search when submitted
  };

  useEffect(() => {
    if (!containerRef.current) return;

    // Initialize the Query Suggestions plugin
    const querySuggestionsPlugin = createQuerySuggestionsPlugin({
      searchClient,
      indexName: 'live_bos_query_suggestions',
      getSearchParams() {
        return {
          hitsPerPage: 5,
        };
      },
    });

    // Initialize Autocomplete with the query suggestions plugin
    const searchAutocomplete = autocomplete({
      container: containerRef.current,
      placeholder: 'Search..',
      detachedMediaQuery: 'none',
      plugins: [querySuggestionsPlugin],
      initialState: {
        query: value,
      },

      onStateChange({ state }) {
        onValueChange?.(state.query);
        setInputValue(state.query);
      },

      onSubmit({ state }) {
        refine(state.query);
      },
    });

    autocompleteRef.current = searchAutocomplete;

    // Cleanup the autocomplete instance when the component unmounts
    return () => {
      searchAutocomplete.destroy();
    };
  }, []);

  // Effect to handle external value changes
  useEffect(() => {
    if (autocompleteRef.current && value !== inputValue) {
      autocompleteRef.current.setQuery(value);
    }
  }, [value]);

  return (
    <form onSubmit={handleSubmit}>
      <div ref={containerRef}></div>
    </form>
  );
};

export default AutocompleteSearch;
